// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_BucketsBlock_card__Cfvts {
  overflow: hidden;
}

.storage_BucketsBlock_card__Cfvts h5 {
  padding: 16px 0 16px 16px;
  font-weight: 700;
}

.storage_BucketsBlock_titleContainer__fzIz2 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.storage_BucketsBlock_tooltipIcon__4EAEE {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.storage_BucketsBlock_tableBlock__3CBBm {
  padding: 0 16px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsBlock/BucketsBlock.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".card {\n  overflow: hidden;\n}\n\n.card h5 {\n  padding: 16px 0 16px 16px;\n  font-weight: 700;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.tooltipIcon {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.tableBlock {\n  padding: 0 16px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `storage_BucketsBlock_card__Cfvts`,
	"titleContainer": `storage_BucketsBlock_titleContainer__fzIz2`,
	"tooltipIcon": `storage_BucketsBlock_tooltipIcon__4EAEE`,
	"tableBlock": `storage_BucketsBlock_tableBlock__3CBBm`
};
export default ___CSS_LOADER_EXPORT___;
